import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import CommonHeadingNBtns from "../../common-components/CommonHeadingNBtns";
import {
  add_fd_incentive_slab,
  update_fd_incentive_slab,
} from "../../../data/ApiEndpoints";
import { commonPostPutApi } from "../../../redux/reducers/commonApiSlice";
import { showConfirmAlert } from "../../components-react/ReactAlert";
import SelectDropdown from "../../components-react/SelectDropdown";
import { fetchGymCategoriesData } from "../../../redux/reducers/dropdownApiSlice";

const FDIncentivesForm = ({
  userInfoData,
  rowData,
  isEdit,
  closeModal,
  callFunction,
}) => {
  const dispatch = useDispatch();
  const { postPutLoading } = useSelector((state) => state.common);
  const { gymCategories } = useSelector((state) => state.dropdown);

  const initialFormValues = {
    selectedCategory:
      isEdit && rowData?.category
        ? {
            value: rowData.category,
            label: rowData.category_name || rowData.category,
          }
        : null,
    revenue: isEdit && rowData?.revenue ? rowData.revenue : "",
    incentive: isEdit && rowData?.incentive ? rowData.incentive : "",
    isActive: isEdit && rowData?.status === "active" ? true : false,
  };
  const [formValues, setFormValues] = useState(initialFormValues);
  const [formErrors, setFormErrors] = useState({});

  const getGymCategories = () => {
    const filters = {
      page: 1,
      limit: 1000,
      status: "active",
    };

    dispatch(
      fetchGymCategoriesData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  };

  const onChangeInput = (e) => {
    const { name, value, type, checked } = e.target;

    setFormValues((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const validateForm = (values) => {
    const errors = {};

    if (!values.selectedCategory) {
      errors.selectedCategory = "Gym category is required!";
    }

    if (!values.revenue) {
      errors.revenue = "Revenue target is required!";
    } else if (isNaN(values.revenue) || Number(values.revenue) <= 0) {
      errors.revenue = "Revenue must be a valid positive number!";
    }

    if (!values.incentive) {
      errors.incentive = "Incentive amount is required!";
    } else if (isNaN(values.incentive) || Number(values.incentive) <= 0) {
      errors.incentive = "Incentive must be a valid positive number!";
    }

    return errors;
  };

  const handleSubmitForm = async (payload) => {
    const method = isEdit ? "PUT" : "POST";
    const endpoint = isEdit ? update_fd_incentive_slab : add_fd_incentive_slab;
    const token = userInfoData?.token || "";

    try {
      const result = await dispatch(
        commonPostPutApi({ method, endpoint, payload, token })
      );

      if (result?.payload?.status) {
        setFormValues(initialFormValues);
        callFunction();
        closeModal();
        toast.success(result?.payload?.message || "Success!");
      } else {
        const errorMessage = result?.payload?.message || result?.error?.message;
        toast.error(errorMessage || "Something Went Wrong!");
      }
    } catch (error) {
      console.error("Error making POST request:", error);
    }
  };

  const onSubmit = (e) => {
    e.preventDefault();
    const errors = validateForm(formValues);
    setFormErrors(errors);

    if (Object.keys(errors).length === 0) {
      const userData = {
        category: formValues.selectedCategory?.value || "",
        revenue: formValues.revenue || "",
        incentive: formValues.incentive || "",
      };

      if (isEdit) {
        userData.uid = rowData?.uid || "";
      }

      const handleConfirm = async () => {
        handleSubmitForm(userData);
      };

      showConfirmAlert(
        handleConfirm,
        `Are you sure!`,
        "Edit Form",
        "Submit Form"
      );
    }
  };

  useEffect(() => {
    getGymCategories();
  }, []);

  return (
    <>
      <CommonHeadingNBtns
        title={`${isEdit ? "Update" : "Add"} FD Incentive Slab`}
        onClose={closeModal}
        btnTxt={isEdit ? "Update" : "Submit"}
        onClick={onSubmit}
        isLoading={postPutLoading}
      />

      <form className="formContainer" onSubmit={onSubmit}>
        <div className="formInputsGrid twoGridSystem">
          <div className="formInputBox">
            <label htmlFor="selectedCategory" className="formInputLabel">
              Gym Category <span className="required">*</span>
            </label>

            <div
              className={`commonWrapper ${
                formErrors.selectedCategory ? "formError" : ""
              }`}
            >
              <SelectDropdown
                name="Gym Category"
                options={gymCategories || []}
                selectedOption={formValues.selectedCategory}
                setSelectedOption={(value) =>
                  setFormValues((prev) => ({
                    ...prev,
                    selectedCategory: value,
                  }))
                }
                isDisable={false}
              />
            </div>

            <span className="error-label">
              {formErrors.selectedCategory || ""}
            </span>
          </div>

          <div className="formInputBox">
            <label htmlFor="revenue" className="formInputLabel">
              Revenue Target (₹) <span className="required">*</span>
            </label>
            <input
              type="number"
              placeholder="Enter Revenue Target"
              className={`formInput ${formErrors.revenue ? "formError" : ""}`}
              name="revenue"
              value={formValues.revenue}
              onChange={onChangeInput}
            />
            <span className="error-label">{formErrors.revenue || ""}</span>
          </div>

          <div className="formInputBox">
            <label htmlFor="incentive" className="formInputLabel">
              Incentive Amount (₹) <span className="required">*</span>
            </label>
            <input
              type="number"
              placeholder="Enter Incentive Amount"
              className={`formInput ${formErrors.incentive ? "formError" : ""}`}
              name="incentive"
              value={formValues.incentive}
              onChange={onChangeInput}
            />
            <span className="error-label">{formErrors.incentive || ""}</span>
          </div>

          <div className="formInputBox checkbox-wrapper span2">
            <div className="flex-box">
              <label className="checkboxLabel">
                <input
                  type="checkbox"
                  name="isActive"
                  checked={formValues.isActive}
                  onChange={onChangeInput}
                />
                {formValues.isActive ? "Active" : "Inactive"}
              </label>
            </div>
          </div>
        </div>
      </form>
    </>
  );
};

export default FDIncentivesForm;
